export default {
  UPLOAD_COVER_IMAGE: 'Upload a show cover image',
  ENTER_VALID_NAME: 'Enter a valid show name',
  ADD_DESCRIPTION: 'Add a show description',
  ADD_RSS_SETTINGS: 'Fill out valid RSS settings',
};
